var _path, _path2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUserIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.26434 0C7.47081 0.0595655 7.68605 0.07601 7.89435 0.133017C9.60933 0.601868 10.7641 2.28103 10.5806 4.04607C10.4023 5.76105 9.10978 7.10913 7.41271 7.34958C5.36154 7.6401 3.44192 6.13306 3.23947 4.07348C3.04104 2.05373 4.45819 0.279556 6.47172 0.027042C6.49292 0.024484 6.51813 0.0299655 6.52581 0H7.26398H7.26434Z",
    fill: "url(#paint0_linear_538_27)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.90789 13.9998C5.02189 13.9998 3.13553 13.9998 1.24953 13.9998C0.90566 13.9998 0.753275 13.8434 0.75766 13.4962C0.79128 10.9667 2.63014 8.76825 5.11179 8.29392C5.40267 8.23837 5.69721 8.20548 5.99394 8.20439C6.58631 8.20256 7.17868 8.19817 7.77068 8.20439C10.1475 8.2296 12.2439 9.85468 12.8666 12.1503C12.9887 12.6005 13.0545 13.0588 13.0603 13.5251C13.064 13.8331 12.9014 13.9991 12.594 13.9994C10.6989 13.9994 8.80339 13.9994 6.90826 13.9994L6.90789 13.9998Z",
    fill: "url(#paint1_linear_538_27)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_538_27",
    x1: 3.22083,
    y1: 3.6927,
    x2: 10.5996,
    y2: 3.6927,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0789E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#00D1C0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_538_27",
    x1: 0.75766,
    y1: 11.1004,
    x2: 13.0603,
    y2: 11.1004,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0789E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#00D1C0"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserIcon);
export default __webpack_public_path__ + "static/media/user_icon.ac5e2aeb5b31a25c02b83100071190a2.svg";
export { ForwardRef as ReactComponent };